import { ElementType } from 'react'

import { MergeElementProps } from '@/lib/core/interfaces/common.types'

import {
  LoaderCircularCircle,
  LoaderCircularIcon,
  LoaderLinearBackground,
  LoaderLinearLoader,
  LoaderWrapper,
} from './Loader.styles'

type LoaderCustomProps<T extends ElementType = ElementType> = MergeElementProps<
  T,
  {
    isLinear?: boolean
    color?: string
    'data-testid'?: string
    WrapperComponent?: T
  }
>

export type LoaderProps<T extends ElementType = ElementType> = Omit<
  MergeElementProps<'div', LoaderCustomProps<T>>,
  'children'
>

export const LoaderComponent = <T extends ElementType = ElementType>({
  isLinear = false,
  WrapperComponent = LoaderWrapper,
  color,
  ...props
}: LoaderProps<T>) => (
  <WrapperComponent {...props} isLinear={isLinear} role="progressbar">
    {isLinear ? (
      <>
        <LoaderLinearLoader />
        <LoaderLinearBackground />
      </>
    ) : (
      <LoaderCircularIcon viewBox="22 22 44 44">
        <LoaderCircularCircle
          color={color}
          cx="44"
          cy="44"
          r="20.2"
          fill="none"
          strokeWidth="3.6"
        />
      </LoaderCircularIcon>
    )}
  </WrapperComponent>
)
